// Demo Mode Configuration
// Set this to true to enable demo mode with automatic 30-second showcase
export const DEMO_MODE_ENABLED = false;

// Demo mode settings
export const DEMO_CONFIG = {
  duration: 36000, // 36 seconds
  autoLogin: true,
  autoLoginDelay: 1500, // 1.5 seconds after language selection
  defaultUser: 'superadmin',
  defaultLanguage: 'en',
  
  // Demo sequence timing (in milliseconds)
  // Stay on dashboard and only switch languages to showcase translation
  sequence: [
    { action: 'login', delay: 0 },
    { action: 'navigate', path: 'dashboard', delay: 2000 },
    { action: 'languageSwitch', lang: 'ka', delay: 4000 },
    { action: 'languageSwitch', lang: 'hy', delay: 7000 },
    { action: 'languageSwitch', lang: 'ru', delay: 10000 },
    { action: 'languageSwitch', lang: 'ky', delay: 13000 },
    { action: 'languageSwitch', lang: 'kk', delay: 16000 },
    { action: 'languageSwitch', lang: 'en', delay: 19000 },
    // Cycle through again
    { action: 'languageSwitch', lang: 'ka', delay: 22000 },
    { action: 'languageSwitch', lang: 'hy', delay: 25000 },
    { action: 'languageSwitch', lang: 'ru', delay: 28000 },
    { action: 'languageSwitch', lang: 'ky', delay: 31000 },
    { action: 'languageSwitch', lang: 'kk', delay: 34000 },
    { action: 'languageSwitch', lang: 'en', delay: 37000 },
  ],
};


